/* DE MAATGIDS — de twee tabrijen (rekenhulp en tabel) kiezen samen.

   Wie in de rekenhulp op "Deken" tikt en dan naar de tabel scrolt, moet daar
   de deken zien en niet het halster. donq-rekenhulp.js schakelt elke rij op
   zichzelf; dit stukje laat de ene rij de andere volgen. Geen eigen beweging:
   de klik doet wat een klik doet, en de streep eronder loopt via de CSS. */
(function () {
  const gids = document.querySelector('.gids');
  if (!gids) return;
  const rijen = [
    [...gids.querySelectorAll('.rekenhulp__tab[data-voor]')],
    [...gids.querySelectorAll('.chart__tab[data-voor]')],
  ].filter(r => r.length);
  if (rijen.length < 2) return;

  let bezig = false;
  rijen.forEach((rij, i) => {
    rij.forEach(knop => knop.addEventListener('click', () => {
      if (bezig) return;
      bezig = true;
      rijen.forEach((andere, j) => {
        if (j === i) return;
        const doel = andere.find(k => k.dataset.voor === knop.dataset.voor);
        if (doel && !doel.classList.contains('is-aan')) doel.click();
      });
      bezig = false;
    }));
  });
})();
